import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NbDialogRef, NbDialogService } from "@nebular/theme";
import * as _ from "lodash";
import * as moment from "moment";
import { LocalDataSource } from "ng2-smart-table";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { User } from "../../../@core/data/users";
import { UserService } from "../../../@core/services/user.service";
import { convertTimestamp } from "../../../@core/utils/convertTimestamps.service";
import { Customer } from "../../../models/customer.model";
import { Dept, DeptDetail } from "../../../models/dept.model";
import { Receipt } from "../../../models/receipt.model";
import Shop from "../../../models/shop.model";

import { CustomerService } from "../../../services/customer.service";
import { FinanceService } from "../../../services/finance.service";
import { ReceiptService } from "../../../services/receipt.service";
import { DialogPrintDeptDetailsComponent } from "../../dialog-print-dept-details/dialog-print-dept-details.component";
import { ShopService } from "../../../services/shop.service";

@Component({
  selector: "ngx-dialog-dept-customer-archive",
  templateUrl: "dialog-dept-customer-archive.component.html",
  styleUrls: ["dialog-dept-customer-archive.component.scss"],
})
export class DialogDeptCustomerArchiveComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() header: string;
  @Input() mode: string;
  @Input() uid: string;
  @Input() shop: Shop;
  @Input() user: User;

  @Input() customerCurrent: Customer = new Customer();

  customerArchived: Customer = new Customer();
  allReceipts?: Receipt[] = [];
  receipts?: Receipt[] = [];
  exportReceipts?: Receipt[] = [];

  allDebits?: Dept[] = [];
  receiptDebits?: Dept[] = [];
  paymentDebits?: Dept[] = [];
  deptDetail?: DeptDetail[] = [];

  periodType = "now";
  periodDate: Date = new Date();
  fromDate: Date = moment().add(-1000, "years").startOf("month").toDate();
  toDate: Date = moment().add(1000, "years").endOf("month").toDate();
  selectedTime: any = null;

  receiptCount = 0;
  source: LocalDataSource = new LocalDataSource();

  saleAmount = 0;
  paidAmount = 0;
  debitAmount = 0;
  discountAmount = 0;
  isDetail = false;

  //display filter by date
  initAmount = 0;
  displaySaleAmount = 0;
  displayPaidAmount = 0;
  displayDebitAmount = 0;
  displayDiscountAmount = 0;
  displayDebits?: Dept[] = [];
  displayDeptDetail?: DeptDetail[] = [];
  displayPaymentDebits?: Dept[] = [];

  submitted = false;
  loading = false;
  changeData = false;
  loaded = false;

  constructor(
    protected ref: NbDialogRef<DialogDeptCustomerArchiveComponent>,
    private userService: UserService,
    private shopService: ShopService,
    private receiptService: ReceiptService,
    private customerService: CustomerService,
    private financeService: FinanceService,
    private router: Router,
    private dialogService: NbDialogService,
  ) {}

  ngOnInit() {
    this.loading = true;
    this.customerService
      .getCustomer(
        this.customerCurrent.shopIdArchived,
        this.customerCurrent.archivedId,
      )
      .then((doc) => {
        console.log("CustomerComponent/getCustomer:", doc.data());

        if (doc.exists) {
          this.customerArchived = doc.data();
          this.customerArchived.id = this.customerCurrent.archivedId;
          this.customerArchived.createdOn = convertTimestamp(
            doc.data().createdOn,
          );

          this.displaySaleAmount = this.saleAmount =
            this.customerArchived.saleAmount;
          this.displayPaidAmount = this.paidAmount =
            this.customerArchived.paidAmount;
          this.displayDebitAmount = this.debitAmount =
            this.customerArchived.debitAmount;

          this.step1_getReceipts();
        } else {
          this.customerArchived.id = "";
        }

        this.loading = false;
      })
      .catch((err) => {
        console.log("CustomerComponent/getCustomer/err:", err);
        this.customerArchived.id = "";
        this.loading = false;
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  close() {
    if (this.loaded && !this.customerCurrent.isInitDept) {
      this.customerCurrent.initAmount = this.debitAmount;
      this.customerCurrent.isInitDept = true;
      this.customerCurrent.isArchived = false;
      this.customerCurrent.isSynced = false;
      this.customerService
        .setCustomerInitAmount(this.customerCurrent)
        .then((data) => {
          this.ref.close(true);
        })
        .catch((err) => {
          this.ref.close(false);
        });
    } else {
      this.ref.close(false);
    }
  }

  //Load data

  private step1_getReceipts() {
    this.loading = true;
    this.receiptService
      .getReceiptTradesByCustomer(
        this.customerArchived.shopId,
        this.customerArchived.id,
      )
      .snapshotChanges(["added", "removed"])
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            id: c.payload.doc.id,
            ...c.payload.doc.data(),
            issueDate: convertTimestamp(c.payload.doc.data().issueDate),
          })),
        ),
        takeUntil(this.destroy$),
      )
      .subscribe(
        (data) => {
          this.receipts = data;
          this.summaryReceipt();
          console.log("getReceipts:", this.receipts);

          this.loading = false;
        },
        (err) => {
          this.receipts = [];
          this.summaryReceipt();
          this.loading = false;
          console.log("getReceipts/err:", err);
        },
      );
  }

  private summaryReceipt() {
    this.saleAmount = 0;
    this.paidAmount = 0;
    this.debitAmount = 0;

    this.receiptDebits = [];
    this.deptDetail = [];

    //initial Amount
    if (this.customerArchived.initAmount !== 0) {
      let initData: Dept = new Dept();
      initData.id = "";
      initData.issueDate = moment().add(-1000, "years").toDate();
      initData.code = "Đầu kỳ";
      initData.note = "Đầu kỳ";
      initData.amount = this.customerArchived.initAmount
        ? this.customerArchived.initAmount
        : 0;
      initData.paid = 0;
      initData.debit = 0;
      initData.mode = "receipt";
      initData.timestamp = initData.issueDate.getTime();
      initData.receipt = null;

      let initDetail: DeptDetail = new DeptDetail();
      initDetail.issueDate = initData.issueDate;
      initDetail.code = initData.code;
      initDetail.note = initData.note;

      initDetail.productId = new Date().getTime().toString();
      initDetail.productCode = "ĐK";
      initDetail.productName = "Đầu kỳ";
      initDetail.productDescription = initData.note;
      initDetail.productUnitName = "";
      initDetail.discountPercent = 0;
      initDetail.discountAmount = 0;
      initDetail.quantity = 1;
      initDetail.price = initData.amount;
      initDetail.amount = initData.amount;
      initDetail.netAmount = initData.amount;
      initDetail.comment = "";
      initDetail.timestamp = initData.issueDate.getTime();

      initData.deptDetails = [initDetail];
      this.deptDetail.push(initDetail);
      this.receiptDebits.push(initData);
    }

    _.forEach(this.receipts, (item) => {
      let expData: Dept = new Dept();
      expData.id = item.id;
      expData.issueDate = item.issueDate;
      expData.code = item.id.substring(item.id.length - 6, item.id.length);
      expData.note = item.note;
      expData.amount = isNaN(item.totalAmount) ? 0 : item.totalAmount;
      expData.paid = 0;
      expData.debit = 0;
      expData.mode = "receipt";
      expData.timestamp = item.issueDate.getTime();
      expData.receipt = item;

      //add detail
      let deptDetails: DeptDetail[] = [];
      _.forEach(item.receiptDetails, (itemD) => {
        let detail: DeptDetail = new DeptDetail();
        detail.issueDate = item.issueDate;
        detail.code = item.id.substring(item.id.length - 6, item.id.length);
        detail.note = item.note;

        detail.productId = itemD.productId;
        detail.productCode = itemD.productCode;
        detail.productName = itemD.productName;
        detail.productDescription = itemD.productDescription;
        detail.productUnitName = itemD.productUnitName;
        detail.discountPercent = itemD.discountPercent;
        detail.discountAmount = itemD.discountAmount;
        detail.quantity = itemD.quantity;
        detail.price = itemD.price;
        detail.amount = isNaN(itemD.amount) ? 0 : itemD.amount;
        detail.netAmount = itemD.netAmount;
        detail.comment = itemD.comment;
        detail.timestamp = item.issueDate.getTime();
        this.deptDetail.push(detail);
        deptDetails.push(detail);
      });
      expData.deptDetails = deptDetails;
      this.receiptDebits.push(expData);
    });

    //Get finances
    this.step2_getFinances();
  }

  private step2_getFinances() {
    this.loading = true;
    this.financeService
      .getFinancesByCustomer(
        this.customerArchived.shopId,
        this.customerArchived.id,
        this.fromDate,
        this.toDate,
      )
      .snapshotChanges(["added", "removed"])
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            id: c.payload.doc.id,
            ...c.payload.doc.data(),
            issueDate: convertTimestamp(c.payload.doc.data().issueDate),
          })),
        ),
        takeUntil(this.destroy$),
      )
      .subscribe((data) => {
        console.log("getFinances:", data);

        this.paymentDebits = [];
        _.forEach(data, (item) => {
          let expData: Dept = new Dept();
          expData.id = item.id;
          expData.issueDate = item.issueDate;
          expData.code = item.id.substring(item.id.length - 6, item.id.length);
          expData.note = item.note;
          expData.amount = 0;
          expData.paid = item.isReceive
            ? item.receiveAmount
            : -item.issueAmount;
          expData.debit = 0;
          expData.mode = "payment";
          expData.timestamp = item.issueDate.getTime();
          expData.payment = item;

          this.paymentDebits.push(expData);
        });

        this.step3_calculateDept();

        this.loading = false;
      });
  }

  private step3_calculateDept() {
    this.saleAmount = 0;
    this.paidAmount = 0;
    this.debitAmount = 0;
    this.discountAmount = 0;

    let depts: Dept[] = [...this.receiptDebits, ...this.paymentDebits];
    depts = _.sortBy(depts, ["issueDate"]);

    this.allDebits = [];
    _.forEach(depts, (item) => {
      let expData: Dept = new Dept();
      expData = item;
      expData.debit = this.debitAmount + (item.amount - item.paid);

      this.allDebits.push(expData);

      this.saleAmount += isNaN(item.amount) ? 0 : item.amount;
      this.paidAmount += item.paid;
      this.debitAmount = expData.debit;

      if (item.receipt && item.receipt.discountAmount != 0) {
        this.discountAmount += item.receipt.discountAmount;
      }

      console.log("step3_calculateDept/saleAmount", this.saleAmount);
      console.log("step3_calculateDept/paidAmount", this.paidAmount);
      console.log("step3_calculateDept/debitAmount", this.debitAmount);
    });

    this.loaded = true;

    this.initAmount = 0;
    this.displaySaleAmount = this.saleAmount;
    this.displayPaidAmount = this.paidAmount;
    this.displayDebitAmount = this.debitAmount;
    this.displayDiscountAmount = this.discountAmount;
    this.displayDebits = [...this.allDebits];
    this.displayDeptDetail = [...this.deptDetail];
    this.displayPaymentDebits = [...this.paymentDebits];

    // this.selectTime(this.selectedTime);
  }
}
